var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(-936.245 -4767.245)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(936.245 4767.245)",
    fill: "#3b57a9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M278.831,280a4.343,4.343,0,0,1,4.347,4.337v6.785a4.344,4.344,0,0,1-4.347,4.337h-8.485A4.343,4.343,0,0,1,266,291.123v-6.785A4.337,4.337,0,0,1,270.346,280Zm1.367,5.617.069-.069a.664.664,0,0,0-.009-.859.723.723,0,0,0-.454-.223.653.653,0,0,0-.482.172l-3.873,3.092a1.345,1.345,0,0,1-1.718,0l-3.865-3.092a.657.657,0,0,0-.92.919l.113.112,3.908,3.049a2.7,2.7,0,0,0,3.357,0Z",
    transform: "translate(678.589 4496.448)",
    fill: "#3b57a9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageImg);
export default __webpack_public_path__ + "static/media/messageImg.b0b4bb05e7035d49a22b37f54336dae2.svg";
export { ForwardRef as ReactComponent };